import type { JobRecord } from '../../api/jobsApi';

/**
 * The job's patient ids, read from its payload (`patient_ids` / `patient_id`).
 *
 * Lives in its own module rather than beside the drawer because it is pure data
 * access with no React in it, and three surfaces need it: the drawer, the admin
 * console, and useScopedJobs. While it sat in JobCenterDrawer.tsx, any test that
 * mocked the drawer component also blanked this function out for everything
 * downstream -- a component mock silently disabling a data reader.
 */
export function jobPatientIds(job: JobRecord): string[] {
  const p = (job.payload ?? {}) as Record<string, unknown>;
  const ids = p.patient_ids;
  if (Array.isArray(ids)) return ids.map((v) => String(v)).filter(Boolean);
  if (typeof p.patient_id === 'string' && p.patient_id) return [p.patient_id];
  return [];
}
